module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-37.d6de1cc9.png";